import * as React from "react";
function SvgCameraOff(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.182 14.982c.01.025.026.048.046.067l5.528 5.529a.833.833 0 01-1.178 1.178L2.244 3.423a.833.833 0 011.179-1.179l4.903 4.904a.207.207 0 00.147.06h6.444a1.25 1.25 0 011.25 1.25v6.444c0 .027.005.054.015.08zM4.638 7.36a.21.21 0 00-.233-.043 1.25 1.25 0 00-.738 1.141v7.5a1.25 1.25 0 001.25 1.25h9.066a.208.208 0 00.147-.355L4.638 7.36zm15.476.85l-2.5 1.425A1.205 1.205 0 0017 10.677v3.063a1.208 1.208 0 00.614 1.042l2.5 1.425A1.25 1.25 0 0022 15.168V9.25a1.25 1.25 0 00-1.886-1.04z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgCameraOff);
export default ForwardRef;
